/* eslint-disable @typescript-eslint/no-explicit-any */
import { Suspense, lazy } from 'react';
import AccessManagement from '../pages/AccessManagement';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';
import PageNotFound from '../components/PageNotFound';
import PageLoader from '../components/PageLoader';
import RequireAuth from '../hoc/CheckAuth';
import { useSelector } from 'react-redux';
import { getUserInfo } from '../reducers/User/actions';
import AppLayout from '../components/AppLayout';
import FileManagement from '../pages/FileManagement';
// import Test from '../pages/ChartsPlayground/Test';
import UserManagement from '../pages/UserManagement';
const Login = lazy(() => import('../pages/Login'));
// const AllCalls = lazy(() => import('../pages/AllCalls'));
// const AuditReview = lazy(() => import('../pages/AuditReview'));
// const CallDetails = lazy(() => import('../pages/CallDetails'));
// const AgentInsights = lazy(() => import('../pages/AgentInsights'));
// const Overview = lazy(() => import('../pages/Overview'));
// const RCA = lazy(() => import('../pages/RCA'));
// const AggregateAgentInsights = lazy(() => import('../pages/AggregateAgentInsights'));
// const AllAgents = lazy(() => import('../pages/AllAgents'));
// const AuditTemplates = lazy(() => import('../pages/AuditConfiguration/AuditTemplates'));
// const AuditParameters = lazy(() => import('../pages/AuditConfiguration/AuditParameters'));
// const AuditParametersCategories = lazy(() => import('../pages/AuditConfiguration/AuditParametersCategories'));
// const Dispositions = lazy(() => import('../pages/AuditConfiguration/Dispositions'));
// const CallsThatNeedAttention = lazy(() => import('../pages/CallsThatNeedAttention'));
// const Account = lazy(() => import('../pages/Account'));
// const PlayGround = lazy(() => import('../pages/PlayGround'));
// const Usage = lazy(() => import('../pages/Usage'));
const AccountLists = lazy(() => import('../pages/AccountLists'));
const OrganizationCreate = lazy(() => import('../pages/OrganizationCreate'));
const QueueList = lazy(() => import('../pages/QueueList'));
const Schedulers = lazy(() => import('../pages/Schedulers'));
const SchedulerOrgDetail = lazy(() => import('../pages/Schedulers/OrgDetail'));
const SchedulerRunDetail = lazy(() => import('../pages/Schedulers/RunDetail'));
const TemplatisationEngine = lazy(() => import('../pages/TemplatisationEngine'));
const TemplateEditor = lazy(() => import('../pages/TemplatisationEngine/editor/TemplateEditor'));
const VoicebotTemplatisation = lazy(() => import('../pages/VoicebotTemplatisation'));
const VoicebotTemplateEditor = lazy(() => import('../pages/VoicebotTemplatisation/editor/VoicebotTemplateEditor'));
// const Billing = lazy(() => import('../pages/Billing'));
// const UnprocessedCalls = lazy(() => import('../pages/UnprocessedCalls'));
// const Settings = lazy(() => import('../pages/Settings'));
// const ManageUsers = lazy(() => import('../pages/Settings/ManageUsers'));
// const ManagePermissions = lazy(() => import('../pages/Settings/ManagePermissions'));
// const OtherSettings = lazy(() => import('../pages/Settings/OtherSettings'));
// const Reports = lazy(() => import('../pages/Reports'));
// const AgentCoaching = lazy(() => import('../pages/AgentCoaching'));
// const AllCustomers = lazy(() => import('../pages/Customers/AllCustomers'));
// const CustomerParameters = lazy(() => import('../pages/Customers/CustomerParameters'));
// const CustomerProfile = lazy(() => import('../pages/Customers/CustomerProfile'));
// const AuditAccuracy = lazy(() => import('../pages/AuditAccuracy'));

export default function RootRoutes() {
  return (
    <BrowserRouter>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          <Route path="/" element={<Navigate to="/account-list" replace />} />
          <Route
            path="/account-list"
            element={
              <RequireAuth>
                <AccountLists />
              </RequireAuth>
            }
          />
          <Route
            path="/account-list/create"
            element={
              <RequireAuth>
                <OrganizationCreate />
              </RequireAuth>
            }
          />
          <Route
            path="/queue-list"
            element={
              <RequireAuth>
                <QueueList />
              </RequireAuth>
            }
          />
          <Route
            path="/schedulers"
            element={
              <RequireAuth>
                <Schedulers />
              </RequireAuth>
            }
          />
          <Route
            path="/schedulers/:orgId"
            element={
              <RequireAuth>
                <SchedulerOrgDetail />
              </RequireAuth>
            }
          />
          <Route
            path="/schedulers/:orgId/runs/:runId"
            element={
              <RequireAuth>
                <SchedulerRunDetail />
              </RequireAuth>
            }
          />
          <Route path="/login" element={<Login />} />

          <Route
            path="/file-management"
            element={
              <RequireAuth>
                <FileManagement />{' '}
              </RequireAuth>
            }
          />
          <Route
            path="/access-management"
            element={
              <RequireAuth>
                <AccessManagement />
              </RequireAuth>
            }
          />
          <Route
            path="/user-management"
            element={
              <RequireAuth>
                <UserManagement />
              </RequireAuth>
            }
          />
          <Route
            path="/templatisation-engine"
            element={
              <RequireAuth>
                <TemplatisationEngine />
              </RequireAuth>
            }
          />
          <Route
            path="/templatisation-engine/:collectionId/edit"
            element={
              <RequireAuth>
                <TemplateEditor />
              </RequireAuth>
            }
          />
          <Route
            path="/voicebot-templates"
            element={
              <RequireAuth>
                <VoicebotTemplatisation />
              </RequireAuth>
            }
          />
          <Route
            path="/voicebot-templates/new"
            element={
              <RequireAuth>
                <VoicebotTemplateEditor />
              </RequireAuth>
            }
          />
          <Route
            path="/voicebot-templates/:templateId/edit"
            element={
              <RequireAuth>
                <VoicebotTemplateEditor />
              </RequireAuth>
            }
          />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
